import type { IconSvgObject } from './types';

const TallyTwoIcon: IconSvgObject = [
  ["path", { d: "M14.5 4V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.5 4V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TallyTwoIcon;
